import {
  Description,
  Label,
} from '@/components/ui/catalyst/fieldset';
import { Radio, RadioField, RadioGroup } from '@/components/ui/catalyst/radio';

interface ProviderTypeSelectorProps {
  value: 'hospital' | 'clinic' | null;
  onChange: (type: 'hospital' | 'clinic') => void;
}

export const ProviderTypeSelector = ({
  value,
  onChange,
}: ProviderTypeSelectorProps) => {
  return (
    <RadioGroup
      value={value ?? ''}
      onChange={(v: string) => onChange(v as 'hospital' | 'clinic')}
    >
      <RadioField>
        <Radio value="hospital" color="blue" />
        <Label>Hospital</Label>
        <Description>
          Large facility with ER, radiology, and billing departments
        </Description>
      </RadioField>
      <RadioField>
        <Radio value="clinic" color="blue" />
        <Label>Non-hospital</Label>
        <Description>
          Doctor&apos;s office, urgent care, or outpatient facility
        </Description>
      </RadioField>
    </RadioGroup>
  );
};
